<template>
    <v-btn :size="size" :outlined="outlined" :dark="!outlined" :type="type" :height="height"
        :color="color" class="boton-suave" :class="{ 'boton-suave--outlined': outlined }">
        <slot>
            <v-icon v-if="prependIcon" right dark> {{ prependIcon }} </v-icon>
            {{ text }}
            <v-icon v-if="appendIcon" right dark> {{ appendIcon }} </v-icon>
        </slot>

    </v-btn>
</template>

<script>

export default {
    props: {
        text: {
            type: String,
            default: 'Guardar Cambios'
        },
        type: {
            type: String,
            default: 'button'
        },
        size: {
            type: String,
            default: 'medium'
        },
        height: {
            type: [String, Number],
            default: undefined
        },
        color: {
            type: String,
            default: '#002245'
        },
        outlined: {
            type: Boolean,
            default: false
        },
        prependIcon: {
            type: String,
            default: ''
        },
        appendIcon: {
            type: String,
            default: ''
        }

    },
};
</script>

<style scoped>
/* Borde apenas redondeado: los botones con texto no van en forma de píldora. */
.boton-suave {
    border-radius: 8px !important;
    text-transform: none !important;
    font-weight: 700;
}
.boton-suave--outlined {
    border-width: 1.5px !important;
}
.boton-suave:not(.boton-suave--outlined) {
    background-color: #002245 !important;
    color: #ffffff !important;
}
.boton-suave:not(.boton-suave--outlined) ::v-deep .v-icon,
.boton-suave:not(.boton-suave--outlined) ::v-deep .v-btn__content {
    color: #ffffff !important;
}
</style>